import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';

export const getBetEventsSelector = (state: RootState) => state.betSystemSliceReducer.betEvents;

export const getBetEventOutcomesMapSelector = (state: RootState) => state.betSystemSliceReducer.betEventOutcomesMap;

export const getBetOutcomesByEventIdSelector = (betEventId: string) =>
  createSelector(getBetEventOutcomesMapSelector, (betEventOutcomesMap) => {
    return betEventOutcomesMap.get(betEventId) ?? [];
  });

export const getProcessingBetEventSelector = (state: RootState) => state.betSystemSliceReducer.processingBetEvent;
export const getProcessingBetOutcomeSelector = (state: RootState) => state.betSystemSliceReducer.processingBetOutcome;

export const getIsBetEventCreateModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetEventCreateModalOpened;
export const getIsBetEventDeleteModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetEventDeleteModalOpened;
export const getIsBetEventEditModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetEventEditModalOpened;
export const getIsBetEventFinishModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetEventFinishModalOpened;
export const getIsBetEventUnfinishModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetEventUnfinishModalOpened;
export const getIsBetOutcomeCreateModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetOutcomeCreateModalOpened;
export const getIsBetOutcomeDeleteModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetOutcomeDeleteModalOpened;
export const getIsBetOutcomeEditModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isBetOutcomeEditModalOpened;
export const getIsExportWinStreaksModalOpenedSelector = (state: RootState) =>
  state.betSystemSliceReducer.isExportWinStreaksModalOpened;
